import type {LedgerReasons} from '@/types/Transaction';

import axios from './axios';

export async function swap(swapParams: {
  fromCurrency: string;
  toCurrency: string;
  amount: number;
  owner: string;
}): Promise<unknown> {
  const response = await axios.post<unknown>(`/v2/admin/transactions/swap`, {
    amount: swapParams.amount,
    fromCurrency: swapParams.fromCurrency,
    toCurrency: swapParams.toCurrency,
    userId: swapParams.owner,
  });
  return response.data;
}

export async function ledger(params: {
  currency: string;
  amount: number;
  userId: string;
  action: 'debit' | 'credit';
  reason: LedgerReasons;
}): Promise<unknown> {
  const response = await axios.post<unknown>(
    `/v2/admin/transactions/ledger`,
    params,
  );
  return response.data;
}
